import React, { useState, useEffect } from 'react';
import moment from 'moment';
import LoadingHolder from 'components/LoadingHolder';
import Container from 'components/Container';
import NotificationBox from 'components/NotificationBox';
import { colorInfo } from 'components/GlobalStyles/variables';
import Term from 'containers/OnePage/Login/TermModal/Term';
import t from 'components/i18n';
import { getTermsOfUse } from '../../service';
import {
  TermWrapper,
  Separator,
} from '../../ProfileAndSettings.styled';

export default function TermsOfUse({ history }) {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(false);

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      try {
        const response = await getTermsOfUse();
        setData(response.data);
      } catch (error) {
        console.error(error);
      }
      setIsLoading(false);
    }
    fetchData();
  }, []);

  return (
    <Container className="container" slim>
      <h4>{t('menu.profile.termsOfUse.title')}</h4>

      <Separator />

      <LoadingHolder isLoading={isLoading} />

      {data && (
        <TermWrapper>
          {data && data.acceptedDate && (
            <NotificationBox
              className="notification notification--info"
              type="warning"
              bgColor={colorInfo}
              slim
            >
              {t('menu.profile.termsOfUse.messageAlert', {
                date: moment(data.acceptedDate).format('DD ̸̸  MM ̸̸  YYYY'),
                hour: moment(data.acceptedDate).format('HH:mm'),
              })}
            </NotificationBox>
          )}
          <br />
          <Term data={data.term} />
        </TermWrapper>
      )}
    </Container>
  );
}
